import { Component, OnInit, Input } from '@angular/core';
import {  Condition, Clause } from '../../models/search-filter-model';
import { SearchFilterComponent } from '../search-filter.component';
import { AlertService } from 'sce-core';
import { ValidatorService } from '../../../services/validator.service';
import { SearchService } from '../../search.service';
import { DataTableEditorService } from '../../results/data-table-editor.service';
import { UserService } from '../../../../core/security/user.service';
import { DatePickerConfigService } from '../../../components/datepicker/datepicker-config.service';

@Component({
  selector: 'lfwms-search-filter-clause',
  templateUrl: './search-filter-clause.component.html',
  styleUrls: ['./search-filter-clause.component.css']
})
export class SearchFilterClauseComponent implements OnInit {

  @Input() clause: Clause;
  @Input() index: number;
  @Input() condition: Condition;
  @Input() filterComponent: SearchFilterComponent;
  @Input() conditionIndex: number;
  @Input() searchService: SearchService;
  // Editor Service for Data Table
  public dataEditor: DataTableEditorService;
  public dateFormat: string;
  public dateTimeFormat: string;

  // import icon path
  public imprtIconPath = 'icon-import.svg';


  private operands = [{ value: '=' },
  { value: '<' },
  { value: '>' },
  { value: '<=' },
  { value: '>=' },
  { value: 'contains' },
  { value: '<>' }];
  // this property holds operands for dropdown and checkbox
  private operandsForDropDownAndCheckBox = [{ value: '=' },
  { value: '<' },
  { value: '>' },
  { value: '<=' },
  { value: '>=' },
  { value: 'contains' },
  { value: '<>' }];
  // this property holds operands for dropdown and checkbox
  private operandsForTextAndDate = [{ value: '=' },
  { value: '<' },
  { value: '>' },
  { value: '<=' },
  { value: '>=' },
  { value: 'contains' },
  { value: 'between' },
  { value: '<>' }];

  private alertService: AlertService;


  constructor(private validatorService: ValidatorService, public userService: UserService,
    public dateConfigService: DatePickerConfigService) {
  }
  // LFWM-862 - type ahead implementation for Search filter
  public ngOnInit() {
    this.dataEditor = this.searchService.searchParams.tableEditor;
    this.filterComponent.criterias.sort((a, b) => (a.name < b.name) ? -1 : 1);
    this.filterComponent.populateDropdownValues();
    // This method will load operands based on data type of first field
    this.populateOperandsDuringPageLoad();
    this.dateFormat = this.dateConfigService.defaultDateDisplayFormat;
    this.dateTimeFormat = this.dateConfigService.defaultDateDisplayFormat + ' ' + this.dateConfigService.defaultTimeDisplayFormat;
  }
  // This method will be used to load operands based on data type of first field
  public populateOperandsDuringPageLoad() {
    if (this.filterComponent.metaDataMap[this.filterComponent.criterias[0].id].type === 'TEXTFIELD'
      || this.filterComponent.metaDataMap[this.filterComponent.criterias[0].id].type === 'DATE') {
      this.operands = this.operandsForTextAndDate;
    } else {
      this.operands = this.operandsForDropDownAndCheckBox;
    }
    if(this.clause && this.clause.column && this.filterComponent.metaDataMap){
      this.clause.typeOfField = this.filterComponent.metaDataMap[this.clause.column].type;
    }
  }
  // method listening to the selection of first criteria dropdown
  public onChange(event: any, index: any) {
    const selectedValue = event.target.value;
    if (this.filterComponent.metaDataMap[selectedValue].type === 'CHECKBOX' ||
      this.filterComponent.metaDataMap[selectedValue].type === 'CHECKBOX_CHR') {
      // Adding CHECKBOX_CHR type denoting the saved value will be 'Y' or 'N'
      // CHECKBOX type denoting the saved value will be '1' or '0'
      this.clause.value = false;
      this.operands = this.operandsForDropDownAndCheckBox;
    } else if (this.filterComponent.metaDataMap[selectedValue].type === 'DROPDOWN' ||
             this.filterComponent.metaDataMap[selectedValue].type === 'EDITABLEDROPDOWN') {
      this.filterComponent.filteredDropdownVal.forEach(dropdownValue => {
        if (dropdownValue.key === selectedValue) {
          // if dropdown values array is empty, then No Options should displayed in a dropdown
          if (dropdownValue.value.length === 0) {
            dropdownValue.value.push({ key: '', value: 'No Options' });
          }
          this.clause.value = dropdownValue.value[0].key;
         /* Start:- Code changes to populate sku abc and loc abc search condition automatically while selecting fastselect value  for abc moves */
          if (this.searchService.searchParams.tableId === 'abcmovestd') {
            if (this.clause.column === 'fastSelect') {
              this.addConditionForSkuAbcAndLocAbcBasedonFastSelectColumn(this.clause.value);
            }
          }
          /*End:- Code changes to populate sku abc and loc abc search condition automatically while selecting fastselect value  for abc moves */
        }
      });
      this.operands = this.operandsForDropDownAndCheckBox;
    } else {
      this.clause.value = '';
      this.clause.value1 = '';
      this.operands = this.operandsForTextAndDate;
    }
    if (this.filterComponent.metaDataMap[selectedValue].defaultOp) {
      this.clause.operation = this.filterComponent.metaDataMap[selectedValue].defaultOp;
    } else {
      this.clause.operation = '=';
    }
    this.clause.typeOfField = this.filterComponent.metaDataMap[selectedValue].type;
    this.filterComponent.dynamicValuesFunction(this.filterComponent.metaDataMap[selectedValue].type, index);
  }

  /* Start:- Code changes to populate sku abc and loc abc search condition automatically while selecting fastselect value  for abc moves */
  public addConditionForSkuAbcAndLocAbcBasedonFastSelectColumn(key: any) {
    this.deleteConditionWithoutIndex(this.filterComponent.metaDataMap['skuABC'].id);
    this.deleteConditionWithoutIndex(this.filterComponent.metaDataMap['locABC'].id);
    if (key === 'CLRSLOWMVFRA') {
      const newCondition = new Condition();
      newCondition.id = this.searchService.getSearchCriteria().conditions.length + 1;
      newCondition.isMandatory = false;
      newCondition.displayMode = 'VIEW';
      newCondition.operator = 'AND';
      newCondition.clauses = [];
      const newClause = new Clause();
      newClause.column = this.filterComponent.metaDataMap['skuABC'].propertyName;
      newClause.id = this.filterComponent.metaDataMap['skuABC'].id;
      newClause.operation = this.filterComponent.metaDataMap['skuABC'].defaultOp;
      newClause.logicalOperation = '';
      newClause.value = 'B';
      newCondition.clauses.push(newClause);
      const newClause1 = new Clause();
      newClause1.column = this.filterComponent.metaDataMap['skuABC'].propertyName;
      newClause1.id = this.filterComponent.metaDataMap['skuABC'].id;
      newClause1.operation = this.filterComponent.metaDataMap['skuABC'].defaultOp;
      newClause1.logicalOperation = 'OR';
      newClause1.value = 'C';
      newCondition.clauses.push(newClause1);
      const newClause2 = new Clause();
      newClause2.column = this.filterComponent.metaDataMap['skuABC'].propertyName;
      newClause2.id = this.filterComponent.metaDataMap['skuABC'].id;
      newClause2.operation = this.filterComponent.metaDataMap['skuABC'].defaultOp;
      newClause2.logicalOperation = 'OR';
      newClause2.value = 'D';
      newCondition.clauses.push(newClause2);
      newCondition.clauses.forEach((clause: any, index: any) => {
        this.filterComponent.dynamicValuesFunction(this.filterComponent.metaDataMap[newClause.column].type, index);
      });
      this.searchService.getSearchCriteria().conditions.push(newCondition);

      // this.searchService.getSearchCriteria().conditions[length].displayMode = 'VIEW';
      const newConditionLoc = new Condition();
      newConditionLoc.id = this.searchService.getSearchCriteria().conditions.length + 1;
      newConditionLoc.isMandatory = false;
      newConditionLoc.displayMode = 'VIEW';
      newConditionLoc.operator = 'AND';
      newConditionLoc.clauses = [];
      const newClauseLoc = new Clause();
      newClauseLoc.column = this.filterComponent.metaDataMap['locABC'].propertyName;
      newClauseLoc.id = this.filterComponent.metaDataMap['locABC'].id;
      newClauseLoc.operation = this.filterComponent.metaDataMap['locABC'].defaultOp;
      newClauseLoc.logicalOperation = '';
      newClauseLoc.value = 'A';
      newConditionLoc.clauses.push(newClauseLoc);
      newConditionLoc.clauses.forEach((clause: any, index: any) => {
        this.filterComponent.dynamicValuesFunction(this.filterComponent.metaDataMap[newClause.column].type, index);
      });
      this.searchService.getSearchCriteria().conditions.push(newConditionLoc);
    } else if (key === 'CLRSLOWMVFRB') {
      const newCondition = new Condition();
      newCondition.id = this.searchService.getSearchCriteria().conditions.length + 1;
      newCondition.isMandatory = false;
      newCondition.displayMode = 'VIEW';
      newCondition.operator = 'AND';
      newCondition.clauses = [];
      const newClause = new Clause();
      newClause.column = this.filterComponent.metaDataMap['skuABC'].propertyName;
      newClause.id = this.filterComponent.metaDataMap['skuABC'].id;
      newClause.operation = this.filterComponent.metaDataMap['skuABC'].defaultOp;
      newClause.logicalOperation = '';
      newClause.value = 'C';
      newCondition.clauses.push(newClause);
      const newClause1 = new Clause();
      newClause1.column = this.filterComponent.metaDataMap['skuABC'].propertyName;
      newClause1.id = this.filterComponent.metaDataMap['skuABC'].id;
      newClause1.operation = this.filterComponent.metaDataMap['skuABC'].defaultOp;
      newClause1.logicalOperation = 'OR';
      newClause1.value = 'D';
      newCondition.clauses.push(newClause1);
      newCondition.clauses.forEach((clause: any, index: any) => {
        this.filterComponent.dynamicValuesFunction(this.filterComponent.metaDataMap[newClause.column].type, index);
      });
      this.searchService.getSearchCriteria().conditions.push(newCondition);

      // this.searchService.getSearchCriteria().conditions[length].displayMode = 'VIEW';
      const newConditionLoc = new Condition();
      newConditionLoc.id = this.searchService.getSearchCriteria().conditions.length + 1;
      newConditionLoc.isMandatory = false;
      newConditionLoc.displayMode = 'VIEW';
      newConditionLoc.operator = 'AND';
      newConditionLoc.clauses = [];
      const newClauseLoc = new Clause();
      newClauseLoc.column = this.filterComponent.metaDataMap['locABC'].propertyName;
      newClauseLoc.id = this.filterComponent.metaDataMap['locABC'].id;
      newClauseLoc.operation = this.filterComponent.metaDataMap['locABC'].defaultOp;
      newClauseLoc.logicalOperation = '';
      newClauseLoc.value = 'B';
      newConditionLoc.clauses.push(newClauseLoc);
      newConditionLoc.clauses.forEach((clause: any, index: any) => {
        this.filterComponent.dynamicValuesFunction(this.filterComponent.metaDataMap[newClause.column].type, index);
      });
      this.searchService.getSearchCriteria().conditions.push(newConditionLoc);
    } else if (key === 'OPTFASTMVTOA') {
      const newCondition = new Condition();
      newCondition.id = this.searchService.getSearchCriteria().conditions.length + 1;
      newCondition.isMandatory = false;
      newCondition.displayMode = 'VIEW';
      newCondition.operator = 'AND';
      newCondition.clauses = [];
      const newClause = new Clause();
      newClause.column = this.filterComponent.metaDataMap['skuABC'].propertyName;
      newClause.id = this.filterComponent.metaDataMap['skuABC'].id;
      newClause.operation = this.filterComponent.metaDataMap['skuABC'].defaultOp;
      newClause.logicalOperation = '';
      newClause.value = 'A';
      newCondition.clauses.push(newClause);
      newCondition.clauses.forEach((clause: any, index: any) => {
        this.filterComponent.dynamicValuesFunction(this.filterComponent.metaDataMap[newClause.column].type, index);
      });
      this.searchService.getSearchCriteria().conditions.push(newCondition);

      // this.searchService.getSearchCriteria().conditions[length].displayMode = 'VIEW';
      const newConditionLoc = new Condition();
      newConditionLoc.id = this.searchService.getSearchCriteria().conditions.length + 1;
      newConditionLoc.isMandatory = false;
      newConditionLoc.displayMode = 'VIEW';
      newConditionLoc.operator = 'AND';
      newConditionLoc.clauses = [];
      const newClauseLoc = new Clause();
      newClauseLoc.column = this.filterComponent.metaDataMap['locABC'].propertyName;
      newClauseLoc.id = this.filterComponent.metaDataMap['locABC'].id;
      newClauseLoc.operation = this.filterComponent.metaDataMap['locABC'].defaultOp;
      newClauseLoc.logicalOperation = '';
      newClauseLoc.value = 'B';
      newConditionLoc.clauses.push(newClauseLoc);

      const newClauseLoc1 = new Clause();
      newClauseLoc1.column = this.filterComponent.metaDataMap['locABC'].propertyName;
      newClauseLoc1.id = this.filterComponent.metaDataMap['locABC'].id;
      newClauseLoc1.operation = this.filterComponent.metaDataMap['locABC'].defaultOp;
      newClauseLoc1.logicalOperation = 'OR';
      newClauseLoc1.value = 'C';
      newConditionLoc.clauses.push(newClauseLoc1);
      const newClauseLoc2 = new Clause();
      newClauseLoc2.column = this.filterComponent.metaDataMap['locABC'].propertyName;
      newClauseLoc2.id = this.filterComponent.metaDataMap['locABC'].id;
      newClauseLoc2.operation = this.filterComponent.metaDataMap['locABC'].defaultOp;
      newClauseLoc2.logicalOperation = 'OR';
      newClauseLoc2.value = 'D';
      newConditionLoc.clauses.push(newClauseLoc2);

      newConditionLoc.clauses.forEach((clause: any, index: any) => {
        this.filterComponent.dynamicValuesFunction(this.filterComponent.metaDataMap[newClause.column].type, index);
      });
      this.searchService.getSearchCriteria().conditions.push(newConditionLoc);

    } else if (key === 'OPTFASTMVTOB') {
      const newCondition = new Condition();
      newCondition.id = this.searchService.getSearchCriteria().conditions.length + 1;
      newCondition.isMandatory = false;
      newCondition.displayMode = 'VIEW';
      newCondition.operator = 'AND';
      newCondition.clauses = [];
      const newClause = new Clause();
      newClause.column = this.filterComponent.metaDataMap['skuABC'].propertyName;
      newClause.id = this.filterComponent.metaDataMap['skuABC'].id;
      newClause.operation = this.filterComponent.metaDataMap['skuABC'].defaultOp;
      newClause.logicalOperation = '';
      newClause.value = 'B';
      newCondition.clauses.push(newClause);
      newCondition.clauses.forEach((clause: any, index: any) => {
        this.filterComponent.dynamicValuesFunction(this.filterComponent.metaDataMap[newClause.column].type, index);
      });
      this.searchService.getSearchCriteria().conditions.push(newCondition);

      // this.searchService.getSearchCriteria().conditions[length].displayMode = 'VIEW';
      const newConditionLoc = new Condition();
      newConditionLoc.id = this.searchService.getSearchCriteria().conditions.length + 1;
      newConditionLoc.isMandatory = false;
      newConditionLoc.displayMode = 'VIEW';
      newConditionLoc.operator = 'AND';
      newConditionLoc.clauses = [];
      const newClauseLoc = new Clause();
      newClauseLoc.column = this.filterComponent.metaDataMap['locABC'].propertyName;
      newClauseLoc.id = this.filterComponent.metaDataMap['locABC'].id;
      newClauseLoc.operation = this.filterComponent.metaDataMap['locABC'].defaultOp;
      newClauseLoc.logicalOperation = '';
      newClauseLoc.value = 'C';
      newConditionLoc.clauses.push(newClauseLoc);

      const newClauseLoc1 = new Clause();
      newClauseLoc1.column = this.filterComponent.metaDataMap['locABC'].propertyName;
      newClauseLoc1.id = this.filterComponent.metaDataMap['locABC'].id;
      newClauseLoc1.operation = this.filterComponent.metaDataMap['locABC'].defaultOp;
      newClauseLoc1.logicalOperation = 'OR';
      newClauseLoc1.value = 'D';
      newConditionLoc.clauses.push(newClauseLoc1);
      newConditionLoc.clauses.forEach((clause: any, index: any) => {
        this.filterComponent.dynamicValuesFunction(this.filterComponent.metaDataMap[newClause.column].type, index);
      });
      this.searchService.getSearchCriteria().conditions.push(newConditionLoc);
    }// checking the count of non mandatory conditions in the formed search criteria
    this.searchService.getSearchCriteria().conditions.forEach((condition) => {
      if (condition.isMandatory === false) {
        this.searchService.setNonMandatoryConditionsCount(this.searchService.getNonMandatoryConditionsCount() + 1);
      }
    });
  }
  /* End:- Code changes to populate sku abc and loc abc search condition automatically while selecting fastselect value  for abc moves */
  // method for deleting a particular condition without index
  public deleteConditionWithoutIndex(conditionId: any) {
    this.searchService.setNonMandatoryConditionsCount(0);
    this.searchService.getSearchCriteria().conditions.forEach((cond: any, index: any) => {
      if (cond.clauses[0].id === conditionId) {
        this.searchService.getSearchCriteria().conditions.splice(index, 1);
      }
    });

    // checking the count of non mandatory conditions in the formed search criteria
    this.searchService.getSearchCriteria().conditions.forEach((condition: any) => {
      if (condition.isMandatory === false) {
        this.searchService.setNonMandatoryConditionsCount(this.searchService.getNonMandatoryConditionsCount() + 1);
      }
    });
  }
  // method to change clause value as per the selected dropdown
  // Intensely written for Transmitlog screen
  public onChangeofValue(event: any, index: any, property: any) {
    const selectedValue = event.target.value;
    const columnDetails = this.filterComponent.metaDataMap['transmitlogTable'];
    if (columnDetails) {
      if (columnDetails.isMandatory && columnDetails.dataType === 'Object') {
        columnDetails.values.forEach(tableid => {
          if (selectedValue === tableid.key) {
            this.filterComponent.type = tableid.value;
            this.searchService.searchParams.tableId = selectedValue;
          }
        });
      }
    }
    /* Start:- Code changes to populate sku abc and loc abc search condition automatically while selecting fastselect value  for abc moves */
    if (this.searchService.searchParams.tableId === 'abcmovestd') {
      if (property === 'fastSelect') {
        this.addConditionForSkuAbcAndLocAbcBasedonFastSelectColumn(event.target.value);
      }
    }
    /* End:- Code changes to populate sku abc and loc abc search condition automatically while selecting fastselect value  for abc moves */
  }

  // method listening to the validation of text fields
  public onTextFieldChange(event: any, clause: any) {
    this.alertService = this.searchService.searchParams.alertService;
    // Reset dropdown values only if storer key is present
    if (clause.column === 'storerKey') {
      this.filterComponent.setDefaultDropdownValues(clause);
    }
    const selectedValue = event.target.value;
    const dataType = this.filterComponent.metaDataMap[clause.column].dataType;
    const validationErrMsg = this.validatorService.validateField(selectedValue, dataType, this.alertService, '');
    if (!(validationErrMsg === '')) {
      this.clause.isValid = false;
      this.clause.validationErrMsg = validationErrMsg;
    } else {
      this.clause.isValid = true;
      this.clause.validationErrMsg = '';
    }
  }

  public onLookupFieldChange(event, fieldIndex) {
    if (0 === fieldIndex) {
      this.clause.value = event.target.value;
    } else {
      this.clause.value1 = event.target.value;
    }
    this.onTextFieldChange(event, this.clause);
  }

  // method for creating new clause
  public addClause() {
    const newClause = new Clause();
    newClause.id = '' + this.condition.clauses.length + 1;
    newClause.column = this.filterComponent.criterias[0].id;
    newClause.operation = this.filterComponent.metaDataMap[newClause.column].defaultOp;
    newClause.value = '';
    newClause.typeOfField = this.filterComponent.metaDataMap[newClause.column].type;
    this.filterComponent
      .dynamicValuesFunction(this.filterComponent.metaDataMap[newClause.column].type, this.condition.clauses.length);
    newClause.logicalOperation = 'AND';
    this.condition.clauses.push(newClause);
  }

  // method for removing one clause
  public removeClause(index: any) {
    this.condition.clauses.splice(index, 1);
    this.condition.clauses.forEach((clause: any, indexNumber: any) => {
      this.filterComponent.dynamicValuesFunction(this.filterComponent.metaDataMap[clause.column].type, indexNumber);
    });
  }

  // method listening  populate the logical operation between various clauses in a particular condition
  public addLogicalOperation(conditionId: any, logOp: any, idx: any) {
    if (this.condition.id === conditionId) {
      this.condition.clauses[idx].logicalOperation = logOp;
    }
  }

  public formatDate(date: string) {
    return date ? this.dateConfigService.getFormattedDisplayDate(date) : null;
  }

  // LFWM-862-method used for binding the selected Autosuggested value to the text field
  public handleSuggestionSelected(clause, selectedValue: any, field: string) {
    if (field === 'firstfield') {
      clause.value = selectedValue;
    } else {
      clause.value1 = selectedValue;
    }
  }

  // JIRA LFWM-1744 Fixes - User chooses multiple search conditions with checkboxes, clicks on one checkbox
  // - action resest selection on all the search condition checkboxes
  public isChkboxChanged(value: any) {
    return !value;
  }

  /**
   * [LFWM-2137] - populating the search condition clauses by values read from input text file
   * importId - colum name of corresponding clause in which the import icon clicked
   */
  public populateSearchCondtionClauseUsingTextFile(event: any) {
    // currentIndex in initialized to zero when uploading new search condition file
    let currentIndex = 0;
    const valueListFromSearchConditionFile = [];
    event.dataFromTxtFile.forEach((valueList: any) => {
      valueList.forEach((value: any) => {
          valueListFromSearchConditionFile.push(value);
        });
    });

    const noOfRemainingClauesNeedsToAddForCurrentColumn = valueListFromSearchConditionFile.length - 1;
    for (let index = 0; index < noOfRemainingClauesNeedsToAddForCurrentColumn ; index++) {
    // here importId is column name
    this.addClauseForValuesFromTxtFile(event.column);
    }

    // updating the condition clauses with values from input file and default logicalOperation = 'OR' as per the requirement
    this.condition.clauses.filter(clause => clause.column === event.column).forEach((clause: any) => {
      if (!clause.value) {
        clause.value = valueListFromSearchConditionFile[currentIndex];
        clause.logicalOperation = 'OR';
        currentIndex += 1;
      }
    });
  }

  // [LFWM-2137] - method to add clause for values from search condition file
  public addClauseForValuesFromTxtFile(column: string) {
    const newClause = new Clause();
    newClause.id = '' + this.condition.clauses.length + 1;
    newClause.column = column;
    newClause.operation = this.filterComponent.metaDataMap[newClause.column].defaultOp;
    newClause.value = '';
    newClause.typeOfField = this.filterComponent.metaDataMap[newClause.column].type;
    this.filterComponent
      .dynamicValuesFunction(this.filterComponent.metaDataMap[newClause.column].type, this.condition.clauses.length);
    newClause.logicalOperation = 'AND';
    this.condition.clauses.push(newClause);
  }

  //[LFWM-3289] - return column indexs at group level.
  public getKeyGrpIndexs(column: string): number[] {
    const keyIndexs = [];
    for (const i in this.condition.clauses) {
      if (this.condition.clauses[i].column === column) {
        keyIndexs.push(+i);
      }
    }
    return keyIndexs;
  }

  public getKeyGrpIndex(column: string): number {
    return this.getKeyGrpIndexs(column).indexOf(this.index);
  }

  // method for creating new clause for already existing column.
  public addKeyGrpClause() {
    const newClause = new Clause();
    newClause.id = '' + this.condition.clauses.length + 1;
    newClause.column = this.clause.column;
    newClause.operation = this.filterComponent.metaDataMap[newClause.column].defaultOp;
    newClause.value = '';
    newClause.typeOfField = this.filterComponent.metaDataMap[newClause.column].type;
    this.filterComponent
      .dynamicValuesFunction(this.filterComponent.metaDataMap[newClause.column].type, this.condition.clauses.length);
    newClause.logicalOperation = 'OR';
    this.condition.clauses.splice(this.index + 1, 0, newClause);
  }

  public get editableDropdownValue(): string {
    const options = this.filterComponent.getOptionsForProperty(this.clause.column);
    const option = options.find(ele => ele.key === this.clause.value);
    if (option) {
      return option.value;
    }
    return this.clause.value;
  }

  public editableDropdownFocus(event: any, edi: any, eds: any) {
    if (event === 'in') {
      edi.classList.add('focus');
      eds.classList.add('focus');
    } else {
      edi.classList.remove('focus');
      eds.classList.remove('focus');
    }
  }
}



// WEBPACK FOOTER //
// /home/runner/work/fbm-fulfillment-wms-client/fbm-fulfillment-wms-client/src/app/shared/search/filter/search-filter-clause/search-filter-clause.component.ts